import {Computed, DataAction, Payload, StateRepository} from "@angular-ru/ngxs/decorators";
import {NgxsAfterBootstrap, State} from "@ngxs/store";
import {createEntityCollections, EntityCollections} from "@angular-ru/cdk/entity";
import {Catalog} from "../../model";
import {EntityIdType} from "@angular-ru/cdk/entity";
import {defaultEntityCollation, EntityCollation, singleRequest} from "../index";
import {Injectable} from "@angular/core";
import {NgxsDataEntityCollectionsRepository} from "@angular-ru/ngxs/repositories";
import {BackendService} from "../../services/backend";
import {tap} from "rxjs";
import * as _ from 'lodash'


export interface CatalogVersions extends Catalog {
  versions: Catalog[]
}

@StateRepository()
@State<EntityCollections<Catalog, EntityIdType, EntityCollation<Catalog>>>({
  name: 'catalogs',
  defaults: {
    ...createEntityCollections(),
    ...defaultEntityCollation()
  }
})
@Injectable()
export class CatalogState extends NgxsDataEntityCollectionsRepository<Catalog, EntityIdType, EntityCollation<Catalog>> implements NgxsAfterBootstrap {

  constructor(private backend: BackendService) {
    super()
  }

  @Computed()
  public get all(): CatalogVersions[] {
    const result = _.orderBy(this.entitiesArray, ['externalId', 'isActive', 'version'], ["asc", "desc", "desc"]);
    const groups = _.groupBy(result, 'externalId')
    const cv = Object.values(groups).map(vs => {
      return {
        ...vs[0],
        versions: vs.slice(1)
      }
    })
    return cv;
  }

  @Computed()
  public get uploadUrl(): string {
    return this.backend.getCatalogUploadUrl();
  }

  @DataAction()
  public getAll() {
    this.ctx.patchState(
      {
        isLoading: true
      }
    )
    return this.backend.getCatalogs().pipe(
      tap(catalogs => {
        this.setAll(catalogs);
        this.ctx.patchState(
          {
            isLoading: false,
            totalCount: catalogs.length
          }
        )
      }),
      singleRequest()
    )
  }

  @DataAction()
  public setActive(@Payload('id') id: string, @Payload('isActive') isActive: boolean) {
    return this.backend.setCatalogActive(id, isActive).pipe(
      tap(catalogs => {
        this.setMany(catalogs)
      }),
      singleRequest()
    )
  }

}
